export var ENTITY = "cost-center";
export var REDUCER_KEY = "COST_CENTER_V2";
export var BASE_PATH_ENTITY = "cost-centers";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
